package one.healthium.profile.navigation.log_water

import com.arkivanov.decompose.ComponentContext

class DefaultLogWaterComponent(
    componentContext: ComponentContext,
    override val taskId: String?,
    private val onCloseClicked: () -> Unit,
) : LogWaterComponent, ComponentContext by componentContext {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }
}